// mantine
import { Paper, Flex, Group, Skeleton, rem, createStyles } from "@mantine/core"
import React from "react"

// ----------------------------------------------------------------------

export const useStyles = createStyles((theme) => ({
  wrapper: {
    [theme.fn.smallerThan("md")]: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
  },

  paper: {
    marginTop: rem(64),
    border: `${rem(1)} solid ${theme.colors.gray[2]}`,
    position: "relative",
    borderRadius: theme.radius.lg,
    padding: rem(48),

    [theme.fn.smallerThan("sm")]: {
      padding: `${rem(48)} ${rem(24)}`,
      marginTop: rem(48),
    },

    [theme.fn.smallerThan("xs")]: {
      padding: `${theme.spacing.xl} ${theme.spacing.md}`,
    },
  },

  desktopDate: {
    paddingLeft: rem(128),
    flexBasis: "40%",

    [theme.fn.smallerThan("lg")]: {
      paddingLeft: rem(96),
      flexBasis: "30%",
    },

    [theme.fn.smallerThan("md")]: {
      display: "none",
    },
  },

  mobileDate: {
    [theme.fn.largerThan("md")]: {
      display: "none",
    },
  },

  about: {
    [theme.fn.smallerThan("md")]: {
      alignItems: "center",
    },
  },

  level: {
    position: "absolute",
    top: 20,
    right: 48,

    [theme.fn.smallerThan("sm")]: {
      display: "none",
    },
  },

  avatar: {
    [theme.fn.smallerThan("md")]: {
      width: rem(140),
      minWidth: rem(140),
      height: rem(140),
    },
  },

  title: {
    [theme.fn.smallerThan("md")]: {
      textAlign: "center",
    },

    [theme.fn.smallerThan("sm")]: {
      fontSize: theme.headings.sizes.h2.fontSize,
    },
  },

  instructorContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.625rem",

    [theme.fn.smallerThan("sm")]: {
      flexWrap: "nowrap",
      flexDirection: "column",
      alignItems: "center",
      gap: "unset",
      marginTop: theme.spacing.sm,
      marginBottom: theme.spacing.sm,
    },
  },
}))

// ----------------------------------------------------------------------

export function ScheduleListSkeleton(): React.JSX.Element {
  const { classes } = useStyles()

  return (
    <>
      {new Array(3).fill(null).map((_, index) => (
        <Paper key={index} className={classes.paper}>
          <Group className={classes.level} position="center">
            <Skeleton height={26} width={160} radius="xl"/>
          </Group>

          <Flex className={classes.wrapper} gap="xl">
            <Flex className={classes.desktopDate} align="flex-start" gap="xl">
              <Skeleton height={96} width={115}/>
              <Flex direction="column" gap={4}>
                <Skeleton height={32} width={110}/>
                <Skeleton height={24} mt="xs" width={80}/>
              </Flex>
            </Flex>

            <Flex className={classes.mobileDate} direction="column" align="center">
              <Skeleton height={32} width={180}/>
              <Skeleton height={24} mt="md" width={90}/>
            </Flex>

            <Flex className={classes.wrapper} align="flex-start" gap="xl">
              <Skeleton height={96} circle className={classes.avatar}/>
              <Flex className={classes.about} direction="column" gap={4}>
                <Skeleton height={32} width={200}/>

                <Flex mt="xs" gap="xs">
                  <Skeleton height={24} width={130}/>
                  <Skeleton height={24} width={130}/>
                </Flex>

                <Skeleton mt="xs" height={24} width={180}/>
              </Flex>
            </Flex>
          </Flex>

          <Group position="center" mt={48}>
            <Skeleton height={36} width={240} radius="xl"/>
            <Skeleton height={36} width={200} radius="xl"/>
          </Group>
        </Paper>
      ))}
    </>
  )
}
